// extracted by mini-css-extract-plugin
export var parcelRow = "_uj-0";